var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWaitWatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.394,
    height: 41.452,
    viewBox: "0 0 41.394 41.452",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.394,
    height: 41.452,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7,41.452A20.821,20.821,0,0,1,.53,25.287a30.446,30.446,0,0,1-.524-4.405,1.834,1.834,0,0,1,1.857-2.058,1.885,1.885,0,0,1,1.9,2.034,16.927,16.927,0,0,0,33.412,3.675A16.927,16.927,0,0,0,20.736,3.764a1.855,1.855,0,0,1-1.914-2.008A1.873,1.873,0,0,1,20.816,0,20.2,20.2,0,0,1,31.581,3.134a20.173,20.173,0,0,1,9.512,14.231,19.937,19.937,0,0,1-4.627,16.675,20.164,20.164,0,0,1-12.44,7.069c-1.1.186-2.217.233-3.326.343",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.906,22.656c0,1.792-.017,3.584.007,5.375a2.046,2.046,0,0,1-1.237,2.041c-2.433,1.2-4.852,2.431-7.285,3.63a1.882,1.882,0,1,1-1.629-3.39c1.994-1,3.985-2,5.987-2.98a.626.626,0,0,0,.414-.663q-.022-4.781-.006-9.561a1.873,1.873,0,1,1,3.743-.092c.016,1.88,0,3.76,0,5.64Z",
    transform: "translate(-11.34 -7.585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.714,27.061a1.889,1.889,0,0,1-1.9-1.853,1.945,1.945,0,0,1,1.934-1.977,1.863,1.863,0,0,1,1.868,1.874,1.93,1.93,0,0,1-1.9,1.955",
    transform: "translate(-1.411 -11.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049,4.728a1.929,1.929,0,0,1-1.955,1.908,1.859,1.859,0,0,1-1.87-1.877,1.948,1.948,0,0,1,1.953-1.92,1.892,1.892,0,0,1,1.872,1.888",
    transform: "translate(-11.646 -1.424)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.881,14.839A1.886,1.886,0,0,1,11,12.963a1.967,1.967,0,0,1,1.928-1.945,1.9,1.9,0,0,1,1.886,1.874,1.987,1.987,0,0,1-1.935,1.947",
    transform: "translate(-5.517 -5.525)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWaitWatch);
export default __webpack_public_path__ + "static/media/icon-wait-watch.f0a40d749a1d9079fcdd49063f63b71d.svg";
export { ForwardRef as ReactComponent };